export enum TransitionDuration {
  Fast = 150,
  Normal = 300,
  Slow = 600,
}
